import { GroupsDiscoverScreen } from 'app/features/group/screens'
import { GroupNavCarousel } from 'app/features/group/components'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { groupsCategoriesQuery, userGroupJoinRequestsQuery } from 'app/features/group/queries'
import { userGroupsQuery } from 'app/features/group/queries'
import { searchGroupsQuery } from 'app/features/group/screens/groups-discover-screen/queries'

export default function Page() {
  return <GroupsDiscoverScreen HeaderComponent={<GroupNavCarousel />} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req }) => {
  const user = req?.session?.user

  const client = initializeApollo({ token: user?.token })
  await client.query({
    query: groupsCategoriesQuery.query,
    variables: {
      ...groupsCategoriesQuery.defaultVariables,
    },
  })

  await client.query({
    query: searchGroupsQuery.query,
    variables: searchGroupsQuery.defaultVariables,
  })

  if (user) {
    await client.query({
      query: userGroupsQuery.query,
      variables: {
        ...userGroupsQuery.defaultVariables,
      },
    })
    await client.query({
      query: userGroupJoinRequestsQuery.query,
      variables: {
        ...userGroupJoinRequestsQuery.defaultVariables,
      },
    })
  }

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
